export default "__VITE_ASSET__BofWH8Gc__"